import { ValidationError } from "@redotech/ui/validator";

/**
 * Validates that each entry is a metafield exclusion string in
 * `namespace.key` or `namespace.key:value` format.
 */
export function variantMetafieldNamespaceValidator(
  value: readonly string[],
): ValidationError[] {
  const errors: ValidationError[] = [];
  for (const entry of value) {
    const [metafieldPart] = entry.split(":");
    const dotIdx = metafieldPart?.indexOf(".") ?? -1;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const namespace = dotIdx > 0 ? metafieldPart!.slice(0, dotIdx) : "";
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const key = dotIdx > 0 ? metafieldPart!.slice(dotIdx + 1) : "";
    if (!namespace || !key) {
      errors.push(
        `"${entry}" must use namespace.key or namespace.key:value format`,
      );
    }
  }
  return errors;
}
